import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=81440b78&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"
import style0 from "./Navigation.vue?vue&type=style&index=0&id=81440b78&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81440b78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81440b78')) {
      api.createRecord('81440b78', component.options)
    } else {
      api.reload('81440b78', component.options)
    }
    module.hot.accept("./Navigation.vue?vue&type=template&id=81440b78&scoped=true", function () {
      api.rerender('81440b78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Navigation.vue"
export default component.exports